export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/SCNotary-acbda9e5919e57523eec39bede333004.PNG";